import { Fragment, memo } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import { RenderModuleRoutesInterface } from './types';

const MemoizedProtectedRoute = memo(ProtectedRoute);

const renderModuleRoutes: RenderModuleRoutesInterface = (routes = []) => {
  if (!routes.length) return null;
  return routes.map(({ id, route: path, component: Component, children }) => (
    <Fragment key={id}>
      {renderModuleRoutes(children)}
      <Route
        path={path}
        element={
          <MemoizedProtectedRoute moduleId={id}>
            {Component && <Component />}
          </MemoizedProtectedRoute>
        }
      />
    </Fragment>
  ));
};

export default renderModuleRoutes;
